export default __webpack_public_path__ + "static/picGuide-3f9d5316070f97e8dc127fe6ccfdb1ae.jpg";